import React from 'react';
import moment from 'moment/moment';
import { CustomDelete } from 'components';
import { Images, useModal } from 'utils';

/**
 * Hook that wraps an action with a future-appointment date warning.
 * If the appointment's startDate is in the future, shows a confirmation modal
 * before executing the action. Otherwise, runs the action immediately.
 *
 * @param {Object} item - Appointment object (needs `startDate`)
 * @returns {Function} checkFutureDateAndRun(actionFn) - wraps actionFn with the warning
 */
export const useFutureApptWarning = (item) => {
    const { open, close } = useModal();

    const checkFutureDateAndRun = (actionFn) => {
        if (!item?.startDate) {
            actionFn();
            return;
        }

        const today = moment.utc().startOf('day');
        const apptDate = moment.utc(item?.startDate).startOf('day');

        if (apptDate.isAfter(today)) {
            open(
                <CustomDelete
                    customConfirmBtn='warning-confirm-btn'
                    innerIcon={Images.alertWarning}
                    info="Future Appointment Warning"
                    text={`You are performing an action on a future appt. This appointment is scheduled for ${moment.utc(item?.startDate).format('MM/DD/YYYY')}`}
                    innerText="Continue anyway"
                    color="blue"
                    handleDel={() => {
                        close();
                        actionFn();
                    }}
                    handleClose={() => close()}
                />
            );
        } else {
            actionFn();
        }
    };

    return checkFutureDateAndRun;
};
